import React from 'react';
import { AdminLayout, PolicyControlDecorated, UploadPermission } from 'pages/administration.page';

/**
 * @param {policyModel[]} policies
 * @param {Function} onRightChangeHandler
 * @param {boolean} withUpload
 * @return {*}
 * @constructor
 */
export const RightsPageView = ({ policies, onRightChangeHandler, withUpload }) => (
  <AdminLayout>
    <div className="policies">
      {policies.map((policy, index) => (
        <PolicyControlDecorated policy={policy} key={index}>
          {withUpload && <UploadPermission policy={policy} onChange={onRightChangeHandler} />}
        </PolicyControlDecorated>
      ))}
    </div>
  </AdminLayout>
);
